exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-wrapper label[data-v-b205fadc] {\n  padding-left: 10px;\n}\n.select-wrapper input[data-v-b205fadc] {\n  margin-left: 20px;\n}\n.contact-info-field[data-v-b205fadc] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.contact-info-field label[data-v-b205fadc] {\n  display: inline-block;\n  width: 330px;\n}\n.contact-info-field .text-input[data-v-b205fadc] {\n  width: 265px;\n  display: block;\n}", ""]);

// exports
